/**
 * Sticky header inside a thread view. Shows the counterparty's display name +
 * shortened raw address.
 *
 * Back navigation: inside Telegram we rely on the native BackButton (wired
 * in ThreadPage). Outside TG we render a chevron in the header so the user
 * has a way back to the inbox.
 */
import { shortenAddress } from "../lib/format";
import { isInTelegram } from "../lib/telegram";

interface Props {
  counterparty: string;
  nickname: string | null;
  onBack: () => void;
}

export function ThreadHeader({ counterparty, nickname, onBack }: Props): JSX.Element {
  const title = nickname ?? shortenAddress(counterparty, 6, 4);
  const showChevron = !isInTelegram();
  return (
    <header className="safe-top sticky top-0 z-10 grid grid-cols-[48px_1fr_48px] items-center border-b border-tg-separator bg-tg-bg px-2 py-2.5">
      <div className="flex justify-start">
        {showChevron ? (
          <button
            type="button"
            onClick={onBack}
            aria-label="Back to inbox"
            className="flex h-8 w-8 items-center justify-center rounded-full text-tg-accent hover:bg-tg-secondary-bg"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        ) : null}
      </div>
      <div className="text-center">
        <div className="text-[15px] font-semibold text-tg-text">{title}</div>
        {nickname !== null ? (
          <div className="font-mono text-[11px] text-tg-hint">
            {shortenAddress(counterparty, 6, 6)}
          </div>
        ) : null}
      </div>
      <div />
    </header>
  );
}
